module.exports = __webpack_public_path__ + "img/logo--sygnet.478c66aa.svg";